import { type Slot } from '../services/appointment/model';

export type Weeks = { date: string; slot: Slot | undefined }[][];

export const chunkArray = <T>(incomingArray: T[], chunkSize: number): T[][] => {
  const result: T[][] = [];
  for (let i = 0; i < incomingArray.length; i += chunkSize) {
    result.push(incomingArray.slice(i, i + chunkSize));
  }
  return result;
};

export const getAdjacentWeeksStartAndEndDate = (adjacentWeeks: Weeks) => {
  if (adjacentWeeks.length === 0) return;
  const firstDay = adjacentWeeks[0][0];
  const lastDay =
    adjacentWeeks[adjacentWeeks.length - 1][
      adjacentWeeks[adjacentWeeks.length - 1].length - 1
    ];
  return {
    firstDayDate: firstDay.date,
    lastDayDate: lastDay.date,
  };
};

export const getNumberOfDaysWithPendingTimeSlots = (
  slots: Slot[],
  selectedSlotIndex: number,
): number => {
  const subArrayOfSlots = slots.slice(selectedSlotIndex);
  const firstIndexOfCompleted = subArrayOfSlots.findIndex(
    (slot) => slot.status === 'completed',
  );
  return firstIndexOfCompleted >= 0
    ? firstIndexOfCompleted
    : subArrayOfSlots.length;
};
